import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useBoolean, useArray, useNumber, useStateful } from 'react-hanger';


const useScrollList = ({
                           getLoader,
                           pageSize = 20
                       }, dependencies = []) => {


    // 所有列表数据
    let list = useArray([])
    // 当前页面
    let page = useNumber(1)
    // 当前页的 列表长度
    let pageListLength = useNumber(0)
    // 总翻页数
    let pageCount = useNumber(0)
    // 是否可以加载更多
    let hasMore = useBoolean(true)
    // 是否为空
    let isEmpty = useBoolean(false)


    let pullTime = useStateful(Date.now())
    let isLoading = useBoolean(true)

    const onPullDown = () => {
        page.setValue(1)
        pullTime.setValue(Date.now())
    }

    const onReachBottom = () => {
        if (!isLoading.value && isHasMore()) {
            // console.log('onReachBottom ===>',hasMore.value,list.value.length)
            page.increase()
        }
    }

    const isHasMore = () => {
        if (list.value.length > 0) {
            if (pageListLength.value === pageSize || (pageCount.value && page.value < pageCount.value)) {
                return true
            } else {
                return false
            }
        }
        return false
    }

    useEffect(() => {
        if (isLoading.value) {
            isEmpty.setFalse()
            hasMore.setTrue()
        } else {
            isEmpty.setValue(list.value.length === 0)
            if (list.value.length > 0) {
                // console.log('hasMore', isHasMore())
                hasMore.setValue(isHasMore())
            } else {
                // 空的 就不显示 更多了
                hasMore.setTrue()
            }
        }

    }, [
        list.value.length,
        isLoading.value,
        pageCount.value
    ])

    useEffect((a) => {
        isLoading.setTrue()
        getLoader(page.value)
            .then((res) => {

                // 兼容格式   res= [] 或者  res = {items:[]}
                let { items, pageCount = 0 } = res;
                if (!items) {
                    items = res || []
                }
                pageListLength.setValue(items.length)

                isLoading.setFalse()
                if (page.value === 1) {
                    list.clear()
                }
                list.push(items);

            })
            .catch((err = {}) => {
                let { loading = false } = err
                if (!loading) {
                    isLoading.setFalse()
                } else {
                    isLoading.setTrue()
                }
            })
    }, [page.value, pullTime.value, ...dependencies])


    return {
        page,
        onPullDown,
        onReachBottom,
        isLoading,
        reload: onPullDown,
        list,
        isEmpty,
        hasMore
    }
}

export default useScrollList;
